import { compose, pluck, path } from 'ramda'
import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { loadProfilesSequence } from '../profiles/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'rideProductSubscriptions'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  loadProfiles,
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
  loadProfiles,
]

export const saveWithoutFeedback = [
  //
  actions.save,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Product subscription saved', type: 'success' }),
  route.toRideProductSubscriptions,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Product subscription deleted', type: 'success' }),
  findForList,
]
